import type { Components } from '@mui/material/styles';

export default function MuiMenuList(): Components['MuiMenuList'] {
  return {};
}
